module.exports = __webpack_public_path__ + "assets/img/cdz.a7922ad6.png";